export function getPackageStatusColor(status) {
  const colors = {
    new: "blue",
    reserved: "purple",
    under_collection: "orange",
    picked_up: "cyan",
    in_transit: "indigo",
    delivered: "green",
    returned: "red",
    pending: "yellow darken-2",
  };

  return colors[status] || "grey";
}
